<template>
  <div class="top-freight">
    <div v-if="isMiniProgram" class="wxmp-nav-right">
      <div class="nav-action" :class="themeColorClass" @click="goRules">
        <span>运费规则</span>
      </div>
    </div>
    <div v-if="topFreightMsg" class="top-msg">{{ topFreightMsg }}</div>
  </div>
</template>
<script>
import themeMixin from '@/common/mixins/theme'
export default {
  name: 'TopMsg',
  mixins: [themeMixin],
  props: {
    isMiniProgram: {
      type: Boolean,
      default: false
    },
    topFreightMsg: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/prop-name-casing
    selected_company_id: {
      type: String,
      default: ''
    }
  },

  methods: {
    goRules() {
      this.$router.push({
        name: 'shipping-fee-rules',
        query: {
          selected_company_id: this.selected_company_id
        }
      })
      this.$track(this.$trackMap.freight.freightDetailRules)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-freight {
  padding: 0.24rem 0.24rem 0;
  .wxmp-nav-right {
    position: relative;

    height: 0.44rem;
    margin-bottom: 0.16rem;
    .nav-action {
      position: absolute;
      right: 0;
      box-sizing: border-box;

      height: 0.44rem;
      padding: 0.02rem 0.18rem;

      background-color: #fff;

      border-radius: 0.18rem;

      font-size: 0.24rem;
      color: #15bb5c;
      @include flex-row-center;
    }
  }

  .top-msg {
    font-size: 0.26rem;
    color: #333;
  }
}
</style>
